import { motion } from 'framer-motion'
import { format } from 'date-fns'
import { CheckCircle } from 'lucide-react'
import { Timestamp } from 'firebase/firestore'

interface PastBookingMessageProps {
  estimatedTime: number | 'unknown'
  earliestDate: Date | Timestamp
}

export function PastBookingMessage({
  estimatedTime,
  earliestDate: earliestDateProp
}: PastBookingMessageProps) {
  // Convert Firestore Timestamps to Date objects
  const bookingDate = earliestDateProp instanceof Timestamp ? earliestDateProp.toDate() : earliestDateProp

  return (
    <div className="w-full mb-4 flex justify-center">
      {/* Full-width container */}
      <motion.div 
        className="rounded-[18px] p-4 shadow-sm w-full max-w-[min(100%,520px)] bg-primary text-white"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        {/* Past Booking Icon and Message */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full flex items-center justify-center bg-white/20">
            <CheckCircle className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-sm text-white">
              Booking Completed
            </h4>
            <div className="text-xs text-white/70 mt-1">
              <div>{format(bookingDate, 'EEEE, MMMM d, yyyy')}</div>
              <div>{format(bookingDate, 'h:mm a')} • {estimatedTime === 'unknown' ? 'Unknown duration' : `${estimatedTime}h`}</div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

